module.exports = __webpack_public_path__ + "img/right-top-radius.3ba6c58c.svg";